import React, { useState, useEffect } from "react";
import Analysis from "./containers/Analysis/Analysis";
import SunTimesHeader from "./SunTimesUI/SunTimesHeader/SunTimesHeader";
import Footer from "./SunTimesUI/Footer/Footer";
import Loading from "./SunTimesUI/Loading/Loading";
import socio from "./data/socio";

const normal = (d) =>
  d.toLowerCase().split("'").join("").split(" ").join("").split("/")[0].trim();

function App() {
  const [homicides, setHomicides] = useState(null);

  async function fetchData() {
    fetch(
      "https://graphics.suntimes.com/data-storage/homicides/tmp/homicides.json"
    )
      .then((response) => response.json())
      .then((data) => {
        const missing_data = data.filter(
          (d) => !d.communityarea || !socio[normal(d.communityarea)]
        );
        console.log("missing data:", missing_data);
        return setHomicides(
          data.filter((d) => d.communityarea && socio[normal(d.communityarea)])
        );
      });
  }

  useEffect(() => fetchData(), []);

  const home = (
    <React.Fragment>
      <SunTimesHeader />
      <Analysis homicides={homicides} />
      <Footer />
    </React.Fragment>
  );

  return homicides ? home : <Loading />;
}

export default App;
